import { gql } from "@apollo/client";

export default gql`
  mutation deleteCoreValueMutation($coreValueId: Int!) {
    deleteCoreValue(coreValueId: $coreValueId) {
      ok
    }
  }
`;
